/**
 * Hairless web entry.
 *
 * The Cloudflare-hosted shell owns Hairless authentication and branding, then
 * mounts the original Cordis/boot-manifest Harness inside the authenticated
 * surface. This keeps the original modules, plugins, files and agent tools in
 * the same project instead of replacing them with a miniature AI page.
 */
import { useEffect, useRef } from 'react'
import { createRoot } from 'react-dom/client'
import { AppWebEntry } from '@hairless/hl-client-web'
import { HairlessAuthGate } from '../../../packages/client/web/src/HairlessAuthGate'

function FullHarnessMount() {
  const mountRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const mount = mountRef.current
    if (mount === null) return undefined
    const entry = new AppWebEntry(mount)
    void entry.run()
    return () => entry.dispose()
  }, [])

  return <div ref={mountRef} style={{ minHeight: '100vh', background: '#101010' }} />
}

const el = document.getElementById('root')
if (el === null) throw new Error('web app: missing #root')

createRoot(el).render(
  <HairlessAuthGate>
    <FullHarnessMount />
  </HairlessAuthGate>,
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined)
  }, { once: true })
}
